<template>
  <div class="custom-input">
    <CustomInput 
      :value="displayValue" 
      :label="label" 
      :required="!!required" 
      :loading="loading"
      :showClearIcon="this.clearable !== false" 
      v-debounce:500="onChange"
      @clear_input="onClear"
    />

    <q-menu :model-value="showDropdown" @update:model-value="val => showDropdown = val" anchor="bottom left"
      self="top left" fit :offset="[0, 8]" no-focus>
      <q-list style="max-height: 250px; overflow:auto; min-width: 100%;">
        <q-item v-if="options?.length" v-for="item in options" :key="item[optionValueKey]" clickable
          @click="handleSelectItem(item)" style="padding: 8px 10px; min-height: auto;">
          <q-item-section style="font-size: 14px; ">
            {{ item[optionLabelKey] }}
          </q-item-section>
        </q-item>
        <q-item v-else class="custom-input__dropdown_item">
          <q-item-section>
            {{ loading ? 'Загрузка...' : 'Ничего не найдено' }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>

<script>
import CustomInput from "../CustomInput"

export default {
  name: "CustomInputDropdown",
  props: [
    "options",
    "required",
    "loading",
    "label",
    "value",
    "optionLabelKey",
    "optionValueKey",
    "clearable"
  ],
  data() {
    return {
      showDropdown: false,
      selectedValue: null,
      selectedItem: null,
    }
  },
  computed: {
    displayValue() {
      if (this.selectedItem && this.selectedItem[this.optionLabelKey]) {
        return this.selectedItem[this.optionLabelKey]
      }
      return this.value || ''
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (!newVal) {
        this.selectedValue = null
        this.selectedItem = null
      } else if (newVal !== oldVal) {
        // Если значение изменилось и это не пустая строка, пытаемся найти элемент
        if (newVal && newVal.length > 0 && this.options && this.options.length > 0) {
          this.$nextTick(() => {
            this.findAndSetSelectedItem(newVal)
          })
        }
      }
    },
    options(newOptions) {
      if (newOptions && newOptions.length > 0) {
        // Если есть значение, но selectedItem не установлен, пытаемся найти его
        if (this.value && !this.selectedItem) {
          this.findAndSetSelectedItem(this.value)
        }
        if (this.value && this.value.length > 0) {
          this.$nextTick(() => {
            this.showDropdown = true
          })
        }
      } else {
        this.showDropdown = false
      }
    }
  },
  mounted() {
    // При монтировании, если есть value, пытаемся найти соответствующий элемент
    this.initializeSelectedItem()
  },
  updated() {
    // При обновлении компонента также проверяем инициализацию
    this.initializeSelectedItem()
  },
  methods: {
    onChange(value) {
      // Если значение изменилось вручную (не через выбор), сбрасываем выбранный элемент
      if (value !== this.displayValue) {
        this.selectedValue = null
        this.selectedItem = null
      }
      this.$emit('change_input', value)
      if (value && value.length > 0 && this.options && this.options.length > 0) {
        this.$nextTick(() => {
          this.showDropdown = true
        })
      } else {
        this.showDropdown = false
      }
    },
    handleSelectItem(item) {
      this.showDropdown = false
      this.selectedValue = item[this.optionValueKey]
      this.selectedItem = item
      this.$emit('select_item', item[this.optionValueKey], item)
    },
    onClear() {
      this.selectedValue = null
      this.selectedItem = null
      this.showDropdown = false
      this.$emit('select_item', null, null)
    },
    findAndSetSelectedItem(value) {
      // Ищем элемент по названию (если value - это текст)
      if (this.options && this.options.length > 0 && value) {
        const foundItem = this.options.find(item => {
          const label = item[this.optionLabelKey]
          return label && label.toString() === value.toString()
        })
        if (foundItem) {
          this.selectedValue = foundItem[this.optionValueKey]
          this.selectedItem = foundItem
          return true
        }
      }
      return false
    },
    initializeSelectedItem() {
      // Инициализируем selectedItem, если есть value, но selectedItem не установлен
      if (this.value && !this.selectedItem && this.options && this.options.length > 0) {
        this.findAndSetSelectedItem(this.value)
      }
    }
  },
  components: { CustomInput }
}
</script>
